export const Camera: React.FC<React.SVGAttributes<{}>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48.1"
      height="36.658"
      viewBox="0 0 48.1 36.658"
      {...props}
    >
      <g transform="translate(-1323.997 -3247.627)">
        <g transform="translate(1330.569 3260.715)">
          <path
            d="M1382.277,3364.09a1.407,1.407,0,1,1,1.407-1.407A1.409,1.409,0,0,1,1382.277,3364.09Z"
            transform="translate(-1380.87 -3361.276)"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.1"
          />
        </g>
        <g transform="translate(1324.047 3247.677)">
          <path
            d="M1363.473,3284.235h-30.851a8.579,8.579,0,0,1-8.574-8.565v-13.15a8.546,8.546,0,0,1,8.574-8.5h10.385a1.158,1.158,0,0,0,1.117-1.193v-1.046a4.13,4.13,0,0,1,4.145-4.106h11.695a4.082,4.082,0,0,1,4.075,4.08v1.292a1.153,1.153,0,0,0,.948,1.1,8.675,8.675,0,0,1,7.062,8.367v13.15A8.579,8.579,0,0,1,1363.473,3284.235Zm-30.851-28.606a6.937,6.937,0,0,0-6.967,6.89v13.15a6.971,6.971,0,0,0,6.967,6.958h30.851a6.971,6.971,0,0,0,6.968-6.958v-13.15a7.064,7.064,0,0,0-5.774-6.792,2.764,2.764,0,0,1-2.236-2.678v-1.292a2.473,2.473,0,0,0-2.468-2.473h-11.695a2.522,2.522,0,0,0-2.538,2.5v1.046a2.766,2.766,0,0,1-2.724,2.8Z"
            transform="translate(-1324.047 -3247.677)"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.1"
          />
        </g>
        <g transform="translate(1343.956 3259.072)">
          <path
            d="M1507.538,3367.007a10.022,10.022,0,1,1,10.023-10.022A10.034,10.034,0,0,1,1507.538,3367.007Zm0-18.438a8.416,8.416,0,1,0,8.416,8.416A8.425,8.425,0,0,0,1507.538,3348.569Z"
            transform="translate(-1497.516 -3346.962)"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.1"
          />
        </g>
        <g transform="translate(1347.952 3263.068)">
          <path
            d="M1538.359,3393.831a6.026,6.026,0,1,1,6.026-6.026A6.033,6.033,0,0,1,1538.359,3393.831Zm0-10.446a4.42,4.42,0,1,0,4.42,4.42A4.425,4.425,0,0,0,1538.359,3383.385Z"
            transform="translate(-1532.333 -3381.778)"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.1"
          />
        </g>
        <g transform="translate(1328.728 3251.318)">
          <path
            d="M1365.636,3284.055a.8.8,0,0,1-.8-.8v-1.125a2.732,2.732,0,0,1,2.729-2.729h1.127a2.642,2.642,0,0,1,2.639,2.639v.765a.8.8,0,1,1-1.607,0v-.765a1.033,1.033,0,0,0-1.032-1.032h-1.127a1.124,1.124,0,0,0-1.122,1.123v1.125A.8.8,0,0,1,1365.636,3284.055Z"
            transform="translate(-1364.833 -3279.398)"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.1"
          />
        </g>
        <g transform="translate(1348.596 3250.59)">
          <path
            d="M1547.9,3278.093h-9.154a.8.8,0,0,1-.8-.8v-3.433a.8.8,0,0,1,.8-.8h9.154a.8.8,0,0,1,.8.8v3.433A.8.8,0,0,1,1547.9,3278.093Zm-8.35-1.607h7.547v-1.826h-7.547Z"
            transform="translate(-1537.941 -3273.054)"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.1"
          />
        </g>
      </g>
    </svg>
  );
};
